import { Navigate, useLocation } from 'react-router-dom';
import auth from './Auth';

export function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!auth.isAutenticado()) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return children;
}
